module.exports = __webpack_public_path__ + "img/icon1.f2ab14f1.png";